import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const FlightTitleIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M4 11.016V8.99998H20V11.016H4ZM14.012 13.032V15H4V13.032H14.012Z'
                fill='currentColor'
            />
        </>
    ),
})

FlightTitleIcon.displayName = 'FlightTitleIcon'
